import axios from 'axios'

const state = {
    course: {},
    courses: {},
    lessons: {},
    lesson: {},
    lesson_files: {},
    vocabularies: {},
    video: {},
    course_rating: {},
    course_errors: {},
    course_loading: false,
}

const getters = {
    course: state => state.course,
    courses: state => state.courses,
    lessons: state => state.lessons,
    course_rating: state => state.course_rating,
    lesson: state => state.lesson,
    lesson_files: state => state.lesson_files,
    vocabularies: state => state.vocabularies,
    video: state => state.video,
    course_errors: state => state.course_errors,
    course_loading: state => state.course_loading,
}

const mutations = {
    setCourse(state, course) {
        state.course = course
    },
    setCourses(state, courses) {
        state.courses = courses
    },
    setLessons(state, lessons) {
        state.lessons = lessons
    },
    setLesson(state, lesson) {
        state.lesson = lesson
    },
    setVocabulary(state, vocabularies) {
        state.vocabularies = vocabularies
    },
    setLessonFiles(state, lesson_files) {
        state.lesson_files = lesson_files
    },
    setVideo(state, video) {
        state.video = video
    },
    setCourseRatings(state, course_rating) {
        state.course_rating = course_rating
    },
    setCourseErrors(state, course_errors) {
        state.course_errors = course_errors
    },
    setCourseLoading(state, course_loading) {
        state.course_loading = course_loading
    },
}

const actions = {
    async storeCourse({commit}, data) {
        commit('setCourseLoading', true)
        commit('setCourseErrors', {})
        try {
            let response = await axios.post(`/api/courses/store`, data)
            commit('setCourseLoading', false)
            commit('setCourseErrors', {})
            return response.data.ok
        } catch (error) {
            console.log(error);
            commit('setCourseLoading', false)
            commit('setCourseErrors', error.response.data.errors)
            return false
        }
    },
    async getMyCourses({commit}, data) {
        commit('setCourseLoading', true)
        try {
            let response = await axios.get(`/api/courses/my`, data)
            commit('setCourses', response.data)
            commit('setCourseLoading', false)
            return response.data.ok
        } catch (error) {
            console.log(error);
            commit('setCourseLoading', false)

            return false
        }
    },
    async getCourses({commit}, data) {
        commit('setCourseLoading', true)
        try {
            let url = `/api/site/courses`
            if (data?.type)
                url += "/" + (data?.type)
            let response = await axios.get(url, {params: data})
            commit('setCourses', data?.type !== 'skill-test' ?  response.data : {data: response.data})
            commit('setCourseLoading', false)
            return response.data.ok
        } catch (error) {
            console.log(error);
            commit('setCourseLoading', false)

            return false
        }
    },
    async getCourse({commit}, id) {
        try {
            let response = await axios.get(`/api/site/courses/${id}/show`)
            commit('setCourse', response.data?.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getActiveCourse({commit}, id) {
        try {
            let response = await axios.get(`/api/courses/${id}/show`)
            commit('setCourse', response.data?.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getCourseLessons({commit}, id) {
        try {
            let response = await axios.get(`/api/site/courses/${id}/lessons`)
            commit('setLessons', response.data?.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getLessons({commit}, id) {
        try {
            let response = await axios.get(`/api/courses/${id}/lessons`)
            commit('setLessons', response.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getLesson({commit}, {course_id, id}) {
        try {
            let response = await axios.get(`/api/courses/${course_id}/lessons/${id}/show`)
            commit('setLesson', response.data?.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getVocabulary({commit}, {course_id, id}) {
        try {
            let response = await axios.get(`/api/courses/${course_id}/lessons/${id}/vocabularies`)
            commit('setVocabulary', response.data?.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getVideo({commit}, {course_id, id}) {
        try {
            let response = await axios.get(`/api/courses/${course_id}/lessons/${id}/video`)
            commit('setVideo', response.data?.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getFiles({commit}, {course_id, id}) {
        try {
            let response = await axios.get(`/api/courses/${course_id}/lessons/${id}/files`)
            commit('setLessonFiles', response.data?.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getCourseRatings({commit}, id) {
        try {
            let response = await axios.get(`/api/site/courses/${id}/ratings`)
            commit('setCourseRatings', response.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async destroyCourse({commit}, id) {
        commit('setCourseLoading', true)
        try {
            let response = await axios.delete(`/api/courses/${id}/destroy`)
            commit('setCourseLoading', false)

            return response.data.ok
        } catch (error) {
            console.log(error);
            commit('setCourseLoading', false)
            return false
        }
    },
    async updateCourse({commit}, data) {
        commit('setCourseLoading', true)
        commit('setCourseErrors', {})
        try {
            let response = await axios.put(`/api/courses/${data.id}/update`, data)
            commit('setCourseLoading', false)
            commit('setCourseErrors', {})
            return response.data
        } catch (error) {
            console.log(error);
            commit('setCourseLoading', false)
            commit('setCourseErrors', error.response.data.errors)
            return false
        }
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}